import type { FC } from 'react';

import { packagingOptions } from '@zen/Components/PackagingTypeSelect/helpers';
import type { Optional } from '@zen/utils/typescript';

import type { FormFieldProps } from '../FormField/types';
import FormSelect from '../FormSelect';

interface Props extends FormFieldProps {
  assignableOnly?: boolean;
  error?: boolean;
  isLoading?: boolean;
  label?: string;
  name: string;
  noMargin?: boolean;
  value?: Optional<string>;
  variant?: 'inline' | 'default';
}

const FormPackagingTypesSelect: FC<Props> = (props) => {
  return (
    <FormSelect
      {...props}
      labelPlacement="left"
      options={packagingOptions}
      placeholder="Select a packaging type..."
      renderMenuInPortal={true}
      shouldFilterResults={false}
    />
  );
};

export default FormPackagingTypesSelect;
